import { useEffect, useState } from 'react';

import { API_URLS } from '@givebacks/api';
import { ButtonMantine, Center } from 'ui';
import { IconApple } from 'ui/Icons';

import { setSsoNext } from '../../utils/localStorage';

declare global {
  interface Window {
    AppleID: any;
  }
}

const AppleSignIn = ({
  setThirdPartyAccountError,
  nextUrl,
}: {
  setThirdPartyAccountError: (str: string) => void;
  nextUrl?: string;
}) => {
  const [appleLoaded, setAppleLoaded] = useState(false);
  async function methodFetch() {
    try {
      await window.AppleID.auth.signIn();
    } catch (err: any) {
      err.json().then((data: any) => {
        setThirdPartyAccountError(data.error);
      });
    }
  }
  useEffect(() => {
    if (!appleLoaded) {
      const embedScript = document.createElement('script');
      embedScript.setAttribute(
        'src',
        '//appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js'
      );
      embedScript.addEventListener('load', () => setAppleLoaded(true));

      document.head.appendChild(embedScript);
    }
  }, [appleLoaded]);

  const handleAppleLogin = async () => {
    nextUrl && setSsoNext(nextUrl);
    await methodFetch();
  };

  useEffect(() => {
    if (appleLoaded) {
      const environment = import.meta.env.VITE_API_ENV || 'staging';
      const redirectUri = API_URLS.CORE + '/auth/apple/new';
      window.AppleID.auth.init({
        clientId: `${environment === 'production' ? 'com' : 'dev'}.givebacks.apple.sign-in-with`,
        scope: 'email name',
        redirectURI: redirectUri,
        usePopup: false,
      });
    }
  }, [appleLoaded]);

  if (!appleLoaded) {
    return null;
  }

  return (
    <Center>
      <ButtonMantine
        size="large"
        fullWidth
        maw={400}
        color="dark"
        onClick={() => {
          setThirdPartyAccountError('');
          handleAppleLogin();
        }}
        variant="filled"
        leftSection={<IconApple size={16} />}
      >
        Sign in with Apple
      </ButtonMantine>
    </Center>
  );
};

export default AppleSignIn;
